import TagsSidebarHeader from './TagsSidebarHeader';
import TagsSidebarBody from './TagsSidebarBody';

const TagsSidebarControls = () => (
  <>
    <TagsSidebarHeader />
    <TagsSidebarBody />
  </>
);

TagsSidebarControls.propTypes = {};

export default TagsSidebarControls;
